import { loadReceivedGifts as loadReceivedGiftsAction } from 'reactApp/modules/giftReceived/actions/load.action';
import { updateReceivedGifts as updateReceivedGiftsAction } from 'reactApp/modules/giftReceived/actions/update.action';

export { loadReceivedGiftsAction, updateReceivedGiftsAction };
